(() => {
  const textUpdates = new Map([
    ["Rashmi Pandey — Founder", "Meet our Founder — Rashmi Pandey"],
    ["M.A. Political Science, Jamshedpur Women's College", "M.A. Political Science, Jamshedpur Women's College, Jamshedpur, INDIA"],
    ["7 years of online teaching experience", "7+ years of online teaching experience"],
    ["60-minute private lessons", "45-minute private lessons"],
  ]);

  const applyUpdates = () => {
    document.querySelectorAll("p, li").forEach((element) => {
      const replacement = textUpdates.get(element.textContent.trim());
      if (replacement) element.textContent = replacement;
    });
  };

  const addQuickContact = () => {
    if (document.querySelector("[data-testid='quick-contact-actions']")) return;
    const actions = document.createElement("div");
    actions.className = "hg-quick-contact";
    actions.dataset.testid = "quick-contact-actions";
    actions.innerHTML = `
      <a class="hg-call-now" href="tel:+917970897238" aria-label="Call Hindi Ganga at +91 79708 97238">☎ Call Now · +91 79708 97238</a>
      <a class="hg-whatsapp-now" href="https://wa.me/917970897238?text=Hello%20Hindi%20Ganga!%20I'd%20like%20to%20know%20more%20about%20your%20classes." target="_blank" rel="noreferrer" aria-label="Chat with Hindi Ganga on WhatsApp"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11.5a8 8 0 0 1-11.7 7l-4.3 1.2 1.3-4A8 8 0 1 1 20 11.5Z"/><path d="M9.2 8.2c.2-.5.5-.5.8-.5h.4c.2 0 .4.1.5.4l.6 1.4c.1.3.1.5-.1.7l-.4.5c.5.9 1.2 1.6 2.1 2.1l.5-.4c.2-.2.4-.2.7-.1l1.4.6c.3.1.4.3.4.5v.4c0 .3 0 .6-.5.8-.4.2-.9.3-1.5.1-1.2-.4-2.4-1.2-3.4-2.2s-1.8-2.2-2.2-3.4c-.2-.6-.1-1.1.1-1.5Z"/></svg></a>
    `;
    document.body.appendChild(actions);
  };

  new MutationObserver(applyUpdates).observe(document.documentElement, { childList: true, subtree: true });
  applyUpdates();
  addQuickContact();
})();
